import React, { useEffect, useRef, useState } from "react";
import ApiClient from "../../../methods/api/apiClient";
import Html from "./html";
import "./style.scss";
import { toast } from "react-toastify";

const ImageUpload = ({
  type="image",
  model,
  result,
  value,
  multiple,
  required,
  className="",
  err,
  accept="image/*",
  label = "",
  apiUrl="upload/multiple-images",
  fileKey="files",
  fallback='',
}) => {
  const inputElement = useRef();
  const [img, setImg] = useState("");
  const [progress, setProgress] = useState(0);
  const [loading, setLoader] = useState(false);

  // const uploadImage = async (e) => {
  //   let url = apiUrl;
  //   let files = e.target.files;
  //   if (files?.length > 1) {
  //     url = apiUrl;
  //   }

  //   let images = [];
  //   if (img) images = img;
  //   if(!files?.length) return
  //   setLoader(true);
  //   ApiClient.multiImageUpload(url, files, {},fileKey,setProgress).then((res) => {
  //     setProgress(0)
  //     if (res.files) {
  //       let image = res.files.map((itm) => itm.fileName);
  //       if (!multiple) {
  //         setImg(image[0]);
  //         result({ event: "value", value: image[0] });
  //       } else {
  //         images = [...images, ...image];
  //         setImg(images);
  //         result({ event: "value", value: images });
  //       }
  //     }
  //     setLoader(false);
  //   });
  // };

  const uploadImage = async (e) => {
  let url = apiUrl;
  let files = e.target.files;

  if (!files?.length) return;
  const imageFiles = Array.from(files).find(file => !(file.type.startsWith("image/")));

    if (type == 'image') {
      if (imageFiles) {
        toast.error("Please upload Images file");
        e.target.value=''
        return
      }
    }
  


  let images = [];
  if (img) images = img;
  
  

  setLoader(true);
  ApiClient.multiImageUpload(url, files, {}, fileKey, setProgress).then((res) => {
    setProgress(0);
    if (res.files) {
      let image = res.files.map((itm) => itm.fileName);
      if (!multiple) {
        setImg(image[0]);
        result({ event: "value", value: image[0] });
      } else {
        images = [...images, ...image];
        setImg(images);
        result({ event: "value", value: images });
      }
    }
     e.target.value=''
    setLoader(false);
  });
};


  const remove = (index) => {
    if (multiple) {
      let images = img.filter((itm, idx) => idx !== index);
      result({ event: "remove", value: images });
      setImg(images);
    } else {
      result({ event: "remove", value: "" });
      setImg("");
    }
  };

  useEffect(() => {
    setImg(value);
  }, [value]);

  return (
    <>
      <Html
        progress={progress}
        accept={accept}
        label={label}
        multiple={multiple}
        inputElement={inputElement}
        uploadImage={uploadImage}
        fallback={fallback}
        img={img}
        model={model}
        required={required}
        className={className}
        loader={loading}
        err={err}
        type={type}
        remove={remove}
      />
    </>
  );
};
export default ImageUpload;
